import { observer } from "mobx-react";
import React, { useEffect } from "react";
import NurseAndCareGiverEmployeeStore from "../../Store/NurseAndCareGiverEmployeeStore";
import ClientStore from "../../Store/ClientStore";
import { Link } from "react-router-dom";
import { stringAvatar } from "../../Utils/Utils";
import { Avatar } from "@mui/material";
import PageTitle from "../../Agency/PageTitle";
import Icon from "../../components/Icons/Icon";

const ClientList = ({ employeeCategory }) => {
  useEffect(() => {
    NurseAndCareGiverEmployeeStore.getEmployeeClientRelation();
  }, []);

  return (
    <div>
      <div className="pageHeaderContainer">
        <PageTitle
          icon={<Icon iconName="menu" />}
          headerTitle="Customer"
          subHeaderTitle="  Customer/Client"
        />
      </div>
      <div className="ClientListMainContainer">
        <div className="headerContainer">
          <div className="headerItem">#MRA</div>
          <div className="headerItem">Name</div>
          <div className="headerItem">Phone</div>
          <div className="headerItem flexLeft">Action</div>
        </div>
        {ClientStore.employeeClientRelationAllData.length === 0 ? (
          <div className="noRecordsMessage">No records available</div>
        ) : (
          ClientStore.employeeClientRelationAllData.map((item, index) => (
            <div className="gridContainer" key={index}>
              <div className="gridItem">{item.mra}</div>
              <div className="gridItem">
                <div className="avatarNameContainer">
                  <Avatar
                    {...stringAvatar(`${item.firstName} ${item.lastName}`)}
                  />
                  <div className="gridItemNameEmail">
                    {`${item.firstName} ${item.lastName}`}

                    <div className="gridItemEmail">{item.email}</div>
                  </div>
                </div>
              </div>
              <div className="gridItem">{item.phoneNo}</div>

              <div className="gridItem flexLeft">
                <Link
                  to={`/care-taker/client_profile/${item.id}`}
                  className="gridItemName"
                >
                  <div className="boderRoundedButton">
                    <Icon iconName="sms" className="boderRoundedButtonIcon" />
                    <span className="boderRoundedButtonText">View Detail</span>
                  </div>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default observer(ClientList);
